import { css } from '@emotion/css';
import { corporateGreyLight, corporateRed } from '../../assets/colors';

export const flexContainer = css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
});

export const wrapper = css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    marginBottom: '1.5mm',
    '& + h2': {
        marginTop: '5mm',
    },
});

export const title = css({
    backgroundColor: 'white',
    fontFamily: 'Proxima Nova',
    fontSize: '24pt',
    fontWeight: 800,
    textTransform: 'uppercase',
    textAlign: 'left',
    color: 'black',
    paddingTop: '3pt',
    paddingBottom: '5mm',
});

export const subTitle = css({
    fontFamily: 'Proxima Nova',
    fontSize: '12pt',
    fontWeight: 800,
    textTransform: 'uppercase',
    color: corporateRed,
    paddingTop: '3pt',
    paddingBottom: '8pt',
});

export const image = css({
    flexShrink: 0,
    width: '37mm',
    objectFit: 'cover',
});

export const keyVisual = css({
    flexShrink: 0,
    height: '70mm',
    objectFit: 'contain',
    marginBottom: '5mm',
});

export const rightMargin = css({
    marginRight: '1.5mm',
});

export const leftMargin = css({
    marginLeft: '1.5mm',
});

export const listBox = css({
    minHeight: '20mm',
    padding: '2mm',
    flexGrow: 1,
    flexShrink: 1,
    backgroundColor: corporateGreyLight,
    '& > ul': {
        padding: 0,
        paddingLeft: '6mm',
        margin: 0,
    },
});

export const listBoxTransparent = css({
    paddingTop: '4mm',
    marginBottom: '-1mm',
    flexGrow: 1,
    flexShrink: 1,
    '& > ul': {
        padding: 0,
        paddingLeft: '6mm',
        margin: 0,
        marginBottom: '5mm',
    },
});

export const gridContainer = css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    columnGap: '1.5mm',
    rowGap: '1.5mm',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    marginBottom: '5mm',
});

export const digiBox = css({
    display: 'flex',
    flexDirection: 'column',
});

export const digiHeaderImg = css({
    flexShrink: 0,
    width: '100%',
    objectFit: 'cover',
});
